import type { HeapIdentity } from '../../heapIdentity.types';

/**
 * Build the HeapIdentity handed to microfrontends.
 *
 * Carries no user identifier by design — identification is host-owned.
 *
 * @returns HeapContext with trainingCenterId and userContactSfId
 */
export function buildHeapContext(): HeapIdentity {
  return {
    trainingCenterId: null, // No mapping yet — extend when TokenData exposes this field
    userContactSfId: null, // No mapping yet — extend when TokenData exposes this field
  };
}
